import { httpClient, mountUrl } from '@/httpClient'

const BASE_URL = '/api/v1/sites/$id/favicon'

export const find = ({ id }) => httpClient.get(mountUrl(BASE_URL, { id }))

export const create = ({ id, favicon }) => httpClient.post(mountUrl(BASE_URL, { id }), { favicon })

export const remove = ({ id }) => httpClient.delete(mountUrl(BASE_URL, { id }))
